import {
  DateField,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import type { RaRecord } from 'ra-core';
import { Chip } from '@mui/material';

type ExpiryRow = RaRecord & { expiryDate?: string };
const daysUntilExpiry = (expiryDate: string) => {

  const now = Date.now();
  const expiryTime = new Date(expiryDate).getTime();
  const msUntilExpiry = expiryTime - now;
  return Math.ceil(msUntilExpiry / (1000 * 60 * 60 * 24));

};
type CertificationExpiryWithDaysCaptionProps = {
  record?: ExpiryRow;
};

function chipColorForExpiryDays(days: number): 'primary' | 'warning' | 'error' {

  if (days > 30) return 'primary';
  if (days < 0) return 'error';
  return 'warning';

}

export const CertificationExpiryWithDaysCaption = (
  props: CertificationExpiryWithDaysCaptionProps & { label?: string },
) => {

  const translate = useTranslate();
  const rowFromContext = useRecordContext<ExpiryRow>();
  const row = props.record ?? rowFromContext;
  if (!row?.expiryDate) {

    return null;

  }
  const days = daysUntilExpiry(row.expiryDate);

  let label = '';
  if (days === 0) {

    label = translate('resources.certification-categories.text.expires_today');

  } else if (days < 0) {

    label = translate('resources.certification-categories.text.already_expired_for', { smart_count: Math.abs(days) });

  } else {

    label = translate('resources.certification-categories.text.days_until_expiry', { smart_count: days });

  }

  return (
    <div
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'center',
        gap: '2px',
      }}
    >
      <DateField
        record={row}
        source="expiryDate"
        label={false}
      />
      <Chip
        label={label}
        color={chipColorForExpiryDays(days)}
        variant="outlined"
        size="small"
      />
    </div>
  );

};
